import { Material, ProductType } from '~/supabase/types'
import { materialKeyMap, materialSignKeyMap, productTypeKeyMap } from '~/utils/constants'

export const generateStockCode = <
  T extends { size: number; setId: number; material: Material; product_type: ProductType },
>(
  data: T
) => {
  const productTypeKey = productTypeKeyMap[data.product_type].toUpperCase()
  const materialKey = materialKeyMap[data.material].toUpperCase()
  const setId = data.setId.toString().padStart(3, '0')
  const size = data.size.toString().padStart(2, '0')
  const codeWithoutMaterialSign = `${materialKey}${productTypeKey}${setId}${size}`

  const materialSign = materialSignKeyMap[data.material]

  return materialSign
    ? `${codeWithoutMaterialSign}${materialSign.toUpperCase()}`
    : codeWithoutMaterialSign
}

export const generatePhotoUrl = ({
  extension = 'webp',
  supplierCode,
  material,
  fileName,
  size,
}: {
  size: 'small' | 'large'
  supplierCode: string
  material: string
  fileName: string
  extension?: string
}) => {
  const projectId = import.meta.env.VITE_API_PROJECT_ID
  if (!projectId) return null
  const width = size === 'small' ? '600' : '900'

  const name = fileName.includes('.webp') ? fileName : `${fileName}.${extension}`

  return `https://${projectId}.supabase.co/storage/v1/render/image/public/photos/${supplierCode}/${material}/${name}?width=${width}&height=${width}`
}
